module.exports = ".panel-heading {\n  display: block;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-align: center;\n  color: #fff;\n  background-color: #fd7e14;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/visio/visio.component.css
// module id = ./src/app/visio/visio.component.css
// module chunks = main